import { makeStyles, Theme, createStyles, Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useEnv from "../../../hooks/env";
import { tesaWhite } from "../../../styles/colors";
import { TesaPrototype, TesaPrototypePagedRes } from "../../../api/models/product/TesaPrototype";
import ProductApi from "../../../api/services/ProductApi";
import CustomButton from "../../../components/Button/CustomButton";
import LaboratoryCreateDialog from "./LaboratoryCreateDialog";
import PrototypeEditCreateDialog from "./PrototypeEditCreateDialog";
import PrototypeOverviewTable from "./PrototypeOverviewTable";
import { CustomTableRowData } from "../../../components/CustomTable";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(3),
    },
    link: {
      color: tesaWhite,
      fontFamily: "Proxima Nova Bold",
      textDecoration: "none",
      "&:hover": {
        color: "rgb(70, 71, 117)",
      },
    },
    marginBottomM: {
      marginBottom: theme.spacing(3),
    },
    marginBottomL: {
      marginBottom: theme.spacing(5),
    },
    marginRight: {
      marginRight: theme.spacing(4),
    },
  }),
);

const PrototypeDbOverview = () => {
  const { api } = useEnv();
  const productApi = new ProductApi(api);
  const classes = useStyles();
  const history = useHistory();
  const recentReqId = localStorage.getItem("recentReqId");
  const recentTab = localStorage.getItem("recentTab");
  const recentDialog = localStorage.getItem("recentDialog");
  const [tesaPrototypePagedRes, setTesaPrototypePagedRes] = useState<TesaPrototypePagedRes>();
  const [prototypeInitialData, setPrototypeInitialData] = useState<TesaPrototype>();
  const [isEditablePrototype, setIsEditablePrototype] = useState(true);
  const [isAddPrototypeDialogOpen, setIsAddPrototypeDialogOpen] = useState(false);
  const [isAddLaboratoryDialogOpen, setIsAddLaboratoryDialogOpen] = useState(false);
  const [submissionSuccessful, setSubmissionSuccessful] = useState("");

  const handleClose = (subSuccess?: boolean, dialog?: string) => {
    if (dialog === "prototype") {
      setIsAddPrototypeDialogOpen(false);
      if (subSuccess) {
        setSubmissionSuccessful("prototype");
        setSubmissionSuccessful("");
      }
    }

    if (dialog === "laboratory") {
      setIsAddLaboratoryDialogOpen(false);
      if (subSuccess) {
        setSubmissionSuccessful("laboratory");
        setSubmissionSuccessful("");
      }
    }
  };

  const handleEdit = (row: CustomTableRowData) => {
    productApi.isEditablePrototype(row.id).then(({ data: isEditable }) => {
      if (isEditable !== isEditablePrototype) {
        setIsEditablePrototype(isEditable);
      }
      setPrototypeInitialData(tesaPrototypePagedRes?.data.find((elm) => elm.id === row.id));
      setIsAddPrototypeDialogOpen(true);
    });
  };

  useEffect(() => {
    // Fetch all prototypes
    productApi
      .getPrototypes()
      .then((res) => {
        setTesaPrototypePagedRes(res.data);
      })
      .catch((e) => console.log(e));
  }, [submissionSuccessful]);

  return (
    <div className={classes.root}>
      <h2>tesa Prototype Database</h2>
      <Box className={classes.marginBottomL} />
      <div>
        <CustomButton
          className={[classes.marginBottomM, classes.marginRight].join(" ")}
          add
          onClick={() => {
            setIsAddPrototypeDialogOpen(true);
          }}
          text="Create tesa Prototype"
        />
        {recentReqId && recentTab ? (
          <CustomButton
            className={classes.marginBottomM}
            onClick={() => {
              const recentReqIdFreeze = recentReqId;
              localStorage.removeItem("recentReqId");
              history.push(`/requests/${recentReqIdFreeze}/${recentTab}${recentDialog && `/${recentDialog}`}`);
            }}
            text="Back to Request"
          />
        ) : (
          <></>
        )}
      </div>
      <PrototypeOverviewTable
        tesaPrototypePagedRes={tesaPrototypePagedRes}
        setTesaPrototypePagedRes={setTesaPrototypePagedRes}
        handleEdit={handleEdit}
      />
      <PrototypeEditCreateDialog
        initialData={prototypeInitialData}
        readonly={!isEditablePrototype}
        openCreateLaboratoryDialog={() => {
          setIsAddLaboratoryDialogOpen(true);
        }}
        onClose={handleClose}
        exitedCallback={() => setPrototypeInitialData(undefined)}
        open={isAddPrototypeDialogOpen}
      />
      <LaboratoryCreateDialog onClose={handleClose} open={isAddLaboratoryDialogOpen} />
    </div>
  );
};

export default PrototypeDbOverview;
